/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./botcode.vue?vue&type=template&id=207114d0&scoped=true"
import script from "./botcode.vue?vue&type=script&lang=js"
export * from "./botcode.vue?vue&type=script&lang=js"
import style0 from "./botcode.vue?vue&type=style&index=0&id=207114d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207114d0",
  null
  
)

export default component.exports